import { Customer } from "../../classes";
import moment from "moment";
import Helper from "../../plugins/Helper/Helper";
const CustomerModule = {
  namespaced: true,
  state: {
    customers: [],
    search: "",
    customer: {},
    searchCustomers: [],
    projectCustomers: [],
    projectCustomerCount: 0
  },
  actions: {
    getCustomers: async ({ commit, rootGetters }, payload) => {
      try {
        const data = await Customer.getCustomersByMarket({
          marketId: rootGetters["markets/getMarketId"]
        });
        commit("setCustomers", { customer: data });
        return data;
      } catch (err) {
        throw err;
      }
    },
    createCustomer: async ({ dispatch, commit, rootGetters }, payload) => {
      try {
        const newObj = {
          ...payload,
          marketId: rootGetters["markets/getMarketId"],
          projectId: rootGetters["markets/getProjectId"],
          incomePerYear: parseFloat(payload.incomePerYear),
          businessStartYear: parseInt(payload.businessStartYear),
          rentalStartYear: parseInt(payload.rentalStartYear),
          dateOfBirth: moment(payload.dateOfBirth).startOf("day"),
          citizenCardExpiryDate: moment(payload.citizenCardExpiryDate).endOf(
            "day"
          ),
          citizenCardIssueDate: moment(payload.citizenCardIssueDate).startOf(
            "day"
          )
        };

        const data = await Customer.createCustomer(newObj);
        dispatch("getCustomers");
        commit("addProjectCustomer", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getCustomer: async ({ commit }, payload) => {
      try {
        const data = await Customer.getCustomer({ id: payload.id });
        commit("setCustomer", { customer: data });
        return data;
      } catch (err) {
        throw err;
      }
    },
    updateCustomer: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const newObj = {
          ...payload,
          incomePerYear: parseFloat(payload.incomePerYear),
          businessStartYear: parseInt(payload.businessStartYear),
          rentalStartYear: parseInt(payload.rentalStartYear),
          dateOfBirth: moment(payload.dateOfBirth).startOf("day"),
          citizenCardExpiryDate: moment(payload.citizenCardExpiryDate).endOf(
            "day"
          ),
          citizenCardIssueDate: moment(payload.citizenCardIssueDate).startOf(
            "day"
          )
        };
        const data = await Customer.updateCustomer(newObj);
        commit("setCustomer", { customer: data });
        commit("updateProjectCustomer", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getCustomerByKeyword: async (
      { commit, rootGetters, dispatch },
      payload
    ) => {
      try {
        const data = await Customer.getCustomerByKeyword({
          keyword: payload.keyword,
          projectId: rootGetters["markets/getProjectId"]
        });
        commit("setSearchCustomer", { customer: data });
        commit("setProjectCustomers", data);
        return data;
      } catch (err) {
        return false;
      }
    },
    getCustomersByProject: async (
      { commit },
      { projectId, limit, page, order }
    ) => {
      try {
        const data = await Customer.getCustomersByProject(
          projectId,
          limit,
          page,
          order
        );
        commit("setProjectCustomers", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getCustomersLengthByProject: async ({ commit }, { projectId }) => {
      try {
        const data = await Customer.getCustomersLengthByProject(projectId);
        commit("setProjectCustomerCount", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    checkTaxID: async ({ commit }, payload) => {
      try {
        let response = await Customer.checkTaxID(payload);
        if (payload.isVat && response) {
          response.companyName = `${response.TitleName} ${response.Name}${response.Surname != '-' ? ' ' + response.Surname : ''}`
          response.HouseNumber = response.HouseNumber.replace(/ /g, "");
          response.BuildingName = response.BuildingName.replace(/ /g, "");
          response.RoomNumber = response.RoomNumber.replace(/ /g, "");
          response.FloorNumber = response.FloorNumber.replace(/ /g, "");
          response.StreetName = response.StreetName.replace(/ /g, "");
          response.SoiName = response.SoiName.replace(/ /g, "");
          response.VillageName = response.VillageName.replace(/ /g, "");
          response.MooNumber = response.MooNumber.replace(/ /g, "");
          response.HouseNumberText = response.HouseNumber != '-' ? `เลขที่ ${response.HouseNumber}` : ''
          response.BuildingNameText = response.BuildingName != '-' ? ` อาคาร ${response.BuildingName}` : ''
          response.RoomNumberText = response.RoomNumber != '-' ? ` ห้องที่ ${response.RoomNumber}` : ''
          response.FloorNumberText = response.FloorNumber != '-' ? ` ชั้น ${response.FloorNumber}` : ''
          response.StreetNameText = response.StreetName != '-' ? ` ถนน ${response.StreetName}` : ''
          response.SoiNameText = response.SoiName != '-' ? ` ซอย ${response.SoiName}` : ''
          response.VillageNameText = response.VillageName != '-' ? ` ชื่อหมู่บ้าน ${response.VillageName}` : ''
          response.MooNumberText = response.MooNumber != '-' ? ` หมู่ที่ ${response.MooNumber}` : ''
          response.addressStreet = `${response.HouseNumberText}${response.BuildingNameText}${response.RoomNumberText}${response.FloorNumberText}${response.SoiNameText}${response.StreetNameText}${response.VillageNameText}${response.MooNumberText}`;
          response.addressSubDistrict = response.Thambol ? ` ตำบล/แขวง ${response.Thambol}` : ''
          response.addressDistrict = response.Amphur ? ` อำเภอ/เขต ${response.Amphur}` : ''
          response.addressProvince = response.Province ? ` จังหวัด ${response.Province}` : '';
          response.addressZipcode = response.PostCode ? ` รหัสไปรษณีย์ ${response.PostCode}` : '';
          response.fullAddress = `${response.addressStreet} ${response.addressSubDistrict} ${response.addressDistrict} ${response.addressProvince} ${response.addressZipcode}`

          response.ststusChecked = { text: '', icon: '', color: '', value: '' }
          if (response.msgerr == '-') {
            response.ststusChecked.value = 'checked'
            response.ststusChecked.color = 'success'
            response.ststusChecked.text = 'พบข้อมูลการจดทะเบียน'
            response.ststusChecked.icon = 'mdi-shield-check-outline'
          } else {
            response.ststusChecked.value = 'error'
            response.ststusChecked.color = 'error'
            response.ststusChecked.text = 'ไม่พบข้อมูลการจดทะเบียน'
            response.ststusChecked.icon = 'mdi-shield-off-outline'
          }
        } else if (!payload.isVat && response) {
          response.DigitOkText = response.DigitOk == 'True' ? 'ถูกต้อง' : 'ไม่ถูกต้อง'
          response.IsExistText = response.IsExist == 'Yes' ? 'มี' : 'ไม่มี'

          response.ststusChecked = { text: '', icon: '', color: '', value: '' }
          if (response.DigitOk == 'True' && response.IsExist == 'Yes' && response.MessageErr == '-') {
            response.ststusChecked.value = 'checked'
            response.ststusChecked.color = 'success'
            response.ststusChecked.text = 'พบข้อมูล'
            response.ststusChecked.icon = 'mdi-shield-check-outline'
          } else if (response.MessageErr != '-') {
            response.ststusChecked.value = 'error'
            response.ststusChecked.color = 'error'
            response.ststusChecked.text = 'ไม่พบข้อมูล'
            response.ststusChecked.icon = 'mdi-shield-off-outline'
          } else if (response.DigitOk == 'True' && response.IsExist != 'Yes' && response.MessageErr == '-') {
            response.ststusChecked.value = 'DigitOk'
            response.ststusChecked.color = 'warning'
            response.ststusChecked.text = 'พบข้อมูล ผลตรวจสอบถูกต้อง แต่ไม่อยู่ในฐานข้อมูลกรมสรรพากร'
            response.ststusChecked.icon = 'mdi-shield-alert-outline'
          } else if (response.DigitOk != 'True' && response.IsExist == 'Yes' && response.MessageErr == '-') {
            response.ststusChecked.value = 'IsExist'
            response.ststusChecked.color = 'warning'
            response.ststusChecked.text = 'พบข้อมูล ผลตรวจสอบไม่ถูกต้อง แต่อยู่ในฐานข้อมูลกรมสรรพากร'
            response.ststusChecked.icon = 'mdi-shield-alert-outline'
          }
        }
        return response;
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    getCustomers: state =>
      state.customers.map(i => {
        i.customerMarketId =
          i?.contracts?.[0]?.customerMarketId ||
          i?.contracts?.[1]?.customerMarketId ||
          i?.contracts?.[2]?.customerMarketId ||
          "-";
        i.erpId = i.erpId || "-";
        i.contractLabel = i.contracts.map(i => i.contractId).join(",");
        i.businessName = i.businessName || "-";
        i.emails = i.emails.length > 0 ? i.emails : ["-"];
        i.tels = i.tels.length > 0 ? i.tels : ["-"];
        i.interTels = i.interTels.length > 0 ? i.interTels : ["-"];
        i.fullName = i.firstName ? i.firstName + " " + i.lastName : "-";
        return i;
      }),
    getSearchCustomers: state =>
      state.searchCustomers.map(i => {
        i.label = i.labelSearch;
        return i;
      }),
    getCustomerId: state => state.customer?.customerId,
    getCustomerObjectId: state => state.customer?.objectId,
    getCustomer: state => state.customer,
    getFullName: state =>
      `${state.customer?.firstName} ${state.customer?.lastName}`,
    getGlobalId: state => ({
      erpId: state.customer.erpId,
      internalId: state.customer.internalId
    }),
    getCustomerContract: state => state.customer.contracts || false,
    getAddressArray: state => {
      if (state.customer.type == "personal") {
        return [
          {
            text:
              "[บัตรปชช.] " +
              state.customer?.addressStreet +
              " " +
              `${state.customer?.addressProvince == "กรุงเทพมหานคร"
                ? "แขวง"
                : Helper.addressPrefix.subDistrict
              }` +
              state.customer?.addressSubDistrict +
              " " +
              `${state.customer?.addressProvince == "กรุงเทพมหานคร"
                ? "เขต"
                : Helper.addressPrefix.district
              }` +
              state.customer?.addressDistrict +
              " " +
              `${state.customer?.addressProvince == "กรุงเทพมหานคร"
                ? ""
                : Helper.addressPrefix.province
              }` +
              state.customer?.addressProvince +
              " " +
              state.customer?.addressZipcode,
            value:
              state.customer?.addressStreet +
              " " +
              `${state.customer?.addressProvince == "กรุงเทพมหานคร"
                ? "แขวง"
                : Helper.addressPrefix.subDistrict
              }` +
              state.customer?.addressSubDistrict +
              " " +
              `${state.customer?.addressProvince == "กรุงเทพมหานคร"
                ? "เขต"
                : Helper.addressPrefix.district
              }` +
              state.customer?.addressDistrict +
              " " +
              `${state.customer?.addressProvince == "กรุงเทพมหานคร"
                ? ""
                : Helper.addressPrefix.province
              }` +
              state.customer?.addressProvince +
              " " +
              state.customer?.addressZipcode
          },
          {
            text:
              "[ทะเบียนบ้าน] " +
              state.customer?.addressHouseStreet +
              " " +
              `${state.customer?.addressHouseProvince == "กรุงเทพมหานคร"
                ? "แขวง"
                : Helper.addressPrefix.subDistrict
              }` +
              state.customer?.addressHouseSubDistrict +
              " " +
              `${state.customer?.addressHouseProvince == "กรุงเทพมหานคร"
                ? "เขต"
                : Helper.addressPrefix.district
              }` +
              state.customer?.addressHouseDistrict +
              " " +
              `${state.customer?.addressHouseProvince == "กรุงเทพมหานคร"
                ? ""
                : Helper.addressPrefix.province
              }` +
              state.customer?.addressHouseProvince +
              " " +
              state.customer?.addressHouseZipcode,
            value:
              state.customer?.addressHouseStreet +
              " " +
              `${state.customer?.addressHouseProvince == "กรุงเทพมหานคร"
                ? "แขวง"
                : Helper.addressPrefix.subDistrict
              }` +
              state.customer?.addressHouseSubDistrict +
              " " +
              `${state.customer?.addressHouseProvince == "กรุงเทพมหานคร"
                ? "เขต"
                : Helper.addressPrefix.district
              }` +
              state.customer?.addressHouseDistrict +
              " " +
              `${state.customer?.addressHouseProvince == "กรุงเทพมหานคร"
                ? ""
                : Helper.addressPrefix.province
              }` +
              state.customer?.addressHouseProvince +
              " " +
              state.customer?.addressHouseZipcode
          },
          {
            text:
              "[ที่อยู่ติดต่อ] " +
              state.customer?.addressContactStreet +
              " " +
              `${state.customer?.addressContactProvince == "กรุงเทพมหานคร"
                ? "แขวง"
                : Helper.addressPrefix.subDistrict
              }` +
              state.customer?.addressContactSubDistrict +
              " " +
              `${state.customer?.addressContactProvince == "กรุงเทพมหานคร"
                ? "เขต"
                : Helper.addressPrefix.district
              }` +
              state.customer?.addressContactDistrict +
              " " +
              `${state.customer?.addressContactProvince == "กรุงเทพมหานคร"
                ? ""
                : Helper.addressPrefix.province
              }` +
              state.customer?.addressContactProvince +
              " " +
              state.customer?.addressContactZipcode,
            value:
              state.customer?.addressContactStreet +
              " " +
              `${state.customer?.addressContactProvince == "กรุงเทพมหานคร"
                ? "แขวง"
                : Helper.addressPrefix.subDistrict
              }` +
              state.customer?.addressContactSubDistrict +
              " " +
              `${state.customer?.addressContactProvince == "กรุงเทพมหานคร"
                ? "เขต"
                : Helper.addressPrefix.district
              }` +
              state.customer?.addressContactDistrict +
              " " +
              `${state.customer?.addressContactProvince == "กรุงเทพมหานคร"
                ? ""
                : Helper.addressPrefix.province
              }` +
              state.customer?.addressContactProvince +
              " " +
              state.customer?.addressContactZipcode
          }
        ];
      } else if (state.customer.type == "company") {
        return [
          {
            text:
              "[ที่อยู่บริษัท] " +
              state.customer?.addressStreet +
              " " +
              `${state.customer?.addressProvince == "กรุงเทพมหานคร"
                ? "แขวง"
                : Helper.addressPrefix.subDistrict
              }` +
              state.customer?.addressSubDistrict +
              " " +
              `${state.customer?.addressProvince == "กรุงเทพมหานคร"
                ? "เขต"
                : Helper.addressPrefix.district
              }` +
              state.customer?.addressDistrict +
              " " +
              `${state.customer?.addressProvince == "กรุงเทพมหานคร"
                ? ""
                : Helper.addressPrefix.province
              }` +
              state.customer?.addressProvince +
              " " +
              state.customer?.addressZipcode,
            value:
              state.customer?.addressStreet +
              " " +
              `${state.customer?.addressProvince == "กรุงเทพมหานคร"
                ? "แขวง"
                : Helper.addressPrefix.subDistrict
              }` +
              state.customer?.addressSubDistrict +
              " " +
              `${state.customer?.addressProvince == "กรุงเทพมหานคร"
                ? "เขต"
                : Helper.addressPrefix.district
              }` +
              state.customer?.addressDistrict +
              " " +
              `${state.customer?.addressProvince == "กรุงเทพมหานคร"
                ? ""
                : Helper.addressPrefix.province
              }` +
              state.customer?.addressProvince +
              " " +
              state.customer?.addressZipcode
          }
        ];
      }
    },
    getCustomerBanking: state => {
      return state.customer?.bankAccounts;
    }
  },
  mutations: {
    setSearchCustomer: (state, payload) => {
      state.searchCustomers = payload.customer;
    },
    setCustomer: (state, payload) => {
      state.customer = payload.customer;
    },
    setCustomers: (state, payload) => {
      state.customers = payload.customer;
    },
    setSearch(state, payload) {
      state.search = payload.search;
    },
    setProjectCustomers(state, customers) {
      state.projectCustomers = customers;
    },
    addProjectCustomer(state, customer) {
      state.projectCustomers.unshift(customer);
      state.projectCustomerCount++;
    },
    updateProjectCustomer(state, customer) {
      if (state.projectCustomers) {
        let index = state.projectCustomers.findIndex(
          i => i.objectId === customer.objectId
        );
        if (index > 0) state.projectCustomers[index] = customer;

        const temp = state.projectCustomers;
        state.projectCustomers = [];
        state.projectCustomers = temp;
      }
    },
    setProjectCustomerCount(state, count) {
      state.projectCustomerCount = count || 0;
    }
  }
};
export default CustomerModule;
